// src/utils/inputFilters.js

export const alphanumericFilter = {
  inserted(el, binding, vnode) {
    const input = el.querySelector("input");

    input.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
      vnode.componentInstance.$emit("input", e.target.value);
    });

    input.addEventListener("keypress", (e) => {
      const charCode = e.charCode ? e.charCode : e.keyCode;
      if (
        charCode === 8 ||
        charCode === 9 ||
        charCode === 13 ||
        charCode === 46 ||
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122)
      ) {
        return true;
      }
      e.preventDefault();
      return false;
    });
  },
};

export const numericFilter = {
  inserted(el, binding, vnode) {
    const input = el.querySelector("input");

    input.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      vnode.componentInstance.$emit("input", e.target.value);
    });

    input.addEventListener("keypress", (e) => {
      const charCode = e.charCode ? e.charCode : e.keyCode;
      if (
        charCode === 8 ||
        charCode === 9 ||
        charCode === 13 ||
        charCode === 46 ||
        (charCode >= 48 && charCode <= 57)
      ) {
        return true;
      }
      e.preventDefault();
      return false;
    });
  },
};

const ALLOWED_SPECIAL_CHARS = [
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  "(",
  ")",
  "-",
  "_",
  "+",
  "=",
  "!",
  "?",
  ".",
  ",",
  ":",
  ";",
  "/",
  "\\",
  "|",
  "[",
  "]",
  "{",
  "}",
  "~",
  "`",
];
export const alphanumericSpecialDirective = {
  inserted(el, binding, vnode) {
    const input = el.querySelector("input");
    input.addEventListener("input", (e) => {
      let value = e.target.value;
      // value = value.replace(/[^a-zA-Z0-9\s]/g, "");
      value = value
        .split("")
        .filter((char) => {
          return (
            /[a-zA-Z0-9]/.test(char) || ALLOWED_SPECIAL_CHARS.includes(char)
          );
        })
        .join("");
      e.target.value = value;
      vnode.componentInstance.$emit("input", value);
    });

    input.addEventListener("keypress", (e) => {
      const charCode = e.charCode ? e.charCode : e.keyCode;
      //   console.log("charCode:", charCode);
      const char = String.fromCharCode(charCode);
      const isAllowed =
        /[a-zA-Z0-9]/.test(char) ||
        ALLOWED_SPECIAL_CHARS.includes(char) ||
        charCode === 8 ||
        charCode === 9 ||
        charCode === 13 ||
        charCode === 46 ||
        (charCode === 32 && binding.value?.allowSpace);
      if (!isAllowed) {
        e.preventDefault();
        return false;
      }
      return true;
    });
  },
};
